document.addEventListener('DOMContentLoaded', function () {

  const widget = document.querySelector('[data-cmn-size-widget]');
  if (!widget) return;

  const widthInput  = document.getElementById('cmn-width');
  const heightInput = document.getElementById('cmn-height');

  if (!widthInput || !heightInput) return;

  // 🔍 Get SIZE variant inputs (hidden)
  function getSizeInputs() {
    return document.querySelectorAll(
      'input[type="radio"][name*="Size"], select[name*="Size"] option'
    );
  }

  // 🧠 Decide size bucket
  function getSizeBucket(w, h) {
    if (w <= 60 && h <= 60) return 'small';
    if (w >= 61 && w <= 150 && h >= 61 && h <= 150) return 'medium';
    if (w >= 151 && h >= 151) return 'large';
    return null;
  }

  // 🔁 Force correct variant
  function syncVariantToSize() {
    const w = parseInt(widthInput.value, 10);
    const h = parseInt(heightInput.value, 10);
    if (!w || !h) return;

    const size = getSizeBucket(w, h);
    if (!size) return;

    getSizeInputs().forEach(el => {
      const val = (el.value || '').toLowerCase();
      if (val.includes(size)) {
        if (el.tagName === 'OPTION') {
          el.parentElement.value = el.value;
          el.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          el.checked = true;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  widthInput.addEventListener('input', syncVariantToSize);
  heightInput.addEventListener('input', syncVariantToSize);

});
